import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';

/**
 * Represents a modal component for displaying a previous version of a fretboard diagram.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {function} props.setIsOld - A function to set the state indicating whether the diagram is old.
 * @param {function} props.setShowCode - A function to set the state indicating whether to show the code.
 * @param {function} props.setShowFretboardModal - A function to set the state indicating whether to show the fretboard modal.
 * @param {function} props.handleSaveButtonClick - A function to handle the save button click event.
 * @param {Object} props.codeDivRef - A reference to the code div element.
 * @returns {JSX.Element} The JSX element representing the OldFretboardModal component.
 */
const OldFretboardModal = ({ setIsOld, setShowCode, setShowFretboardModal, handleSaveButtonClick, codeDivRef }) => {
    const [open, setOpen] = React.useState(true);

    const handleClose = (event, reason) => {
        if (reason === "backdropClick") {
            return;
        }
        setOpen(false);
        setIsOld(false);
    };

    const handleShowCode = () => {
        // TODO: Implement the logic for showing the code
        setIsOld(false);
        setShowCode(true);
        setOpen(false);
        setShowFretboardModal(true);

    };

    const handleAddDiagram = (event) => {
        // TODO: Implement the logic for adding a diagram
        setIsOld(false);
        setShowCode(false);
        setOpen(false);
        handleSaveButtonClick(event);
        codeDivRef.value = "";
    };

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Previous Version Fretboard</DialogTitle>
            <DialogContent>
                <p>You cannot make changes to this fretboard diagram using the new interface as it is from a previous version. You have two choices,
                    you can either add this diagram to your fretboard collection as is, and then start a new fretboard using the new interface or you can
                    continue to view the code for this diagram and the new interface will be disabled.</p>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleShowCode} color="primary">
                    Continue with Code
                </Button>
                <Button id="old-menu-handle-add-diagram" onClick={handleAddDiagram} color="primary">
                    Add Diagram and Start New
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default OldFretboardModal;
